import { T0, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledPageMainTitle = styled(T0)`
  text-transform: none;  
  font-size: 40px;

  ${media.sm`
    font-size: 48px;
  `}
`;
